module.exports = __webpack_public_path__ + "img/stock4.58fb3025.png";